module.exports = __webpack_public_path__ + "static/UnclickPermanentlyDisabledYellow-c5ea189c29910a4eb0edbfbfebc380ec.png";